import React, { useEffect, useState, useRef, Suspense } from 'react';
import Game from '../../../../class/Game/Game';
import Games from '../../../../class/Game_copy/Game';
import { openGameModal } from '../../modal/modal_game';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import crashGameIcon from '../../static/img/icon-btn/crash-game-icon.png';
import LOAD_GAMES_BY_CATEGORY from '../../modal/load_games_by_category.js';
import ModalLogin from '../../modal/modal_login.js';

import { useTranslation } from 'react-i18next';

const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;


const LoadCategory = ({ category, limit = 30, page = 1, AuthService, isLogged, setIsLoginModalOpen }) => {
  const { t } = useTranslation();
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [customClass, setCustomClass] = useState('');
  const sliderRef = useRef(null);

  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const handleOpenCategoryModal = () => setShowCategoryModal(true);
  const handleCloseCategoryModal = () => setShowCategoryModal(false);


  const slidesToShow = 6;
  const user_id = AuthService.getCustom('user_id');

  const updateFavoriteGame = async (newGameId ) => {
    if (isLogged) {
      try {
        // Получаем инфу об игре
        const gameInfo = await Games.getGameInfo(newGameId);
        const gameType = gameInfo?.params?.game_info[0]?.category_slug || '';

        const user_id = await AuthService.getCustom('user_id');
        const lastGames = await Games.updateFavoriteGames(user_id, gameType, newGameId );
        
        // console.log("NUOVO GIOCO PREFERITO");

      } catch (error) {
        console.error('Failed to fetch game info or open game:', error);
      }
    } else if (!isLogged) {
      setIsLoginModalOpen(true);
      console.error(t('User_is_not_logged_in.'));
    }

    // console.log('ModalGame opened with gameId:', [newGameId, isLogged]);
  };

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const response = await Games.getGameByCategory(category, limit, page, user_id);
        // const response = await Games.getGameByCategory(category, limit, page, user_id);
        
        // console.log(response)
        const result = response.params?.games || [];
        setGames(result);
        setCustomClass(result.length === 1 ? 'single' : 'multiple');
      } catch (error) {
        console.error('Error loading category games:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGames();
  }, [category, limit, page]);

  const getProviderIcon = (provider_slug) =>
    `${cmsUrl}static-assets/providers/${provider_slug}.png`;
  

  const getCategoryIcon = (category) =>
    `${cmsUrl}static/img/icon-btn/${category}-icon.png`;
  
  const isSliderInfinite = games.length > slidesToShow;

  const settings = {
    dots: false,
    infinite: isSliderInfinite,
    speed: 800,
    slidesToShow,
    slidesToScroll: 3,
    ref: sliderRef,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 2 } },
      { breakpoint: 960, settings: { slidesToShow: 4, slidesToScroll: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 4 } },
      { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    ],
  };

  const renderLoadingGames = () =>
    Array.from({ length: 6 }).map((_, index) => (
      <div key={index} className="HomeSectionCasinoGames_game">
        <div className="CasinoGameCard_root">
          <div className="CasinoGamePreview_root blurred">
            <div className="CasinoGamePreview_gradient"></div>
            <img
              className="ResponsivePicture_img CasinoGamePreview_image"
              src="https://storage.googleapis.com/camasy-images/casino/only__play__619cb11478244.png"
              style={{ filter: 'blur(10px)' }}
              alt="Loading..."
            />
          </div>
          <div className="CasinoGameCard_info CasinoGameCard_withProvider">
            <div className="CasinoGameCard_icon_placeholder"></div>
            <p className="CasinoGameCard_name_placeholder" style={{ filter: 'blur(10px)' }}>
              {t('loading')}...
            </p>
          </div>
        </div>
      </div>
    ));

  return (
    <>
      <div className={`slide-general-game ${customClass}`}>
        <div className="body main-layout-item">
          <div className="Home_root">
            <div className="Home_games">
              <div className="Home_header">
                <a className="HomeSection_header">
                <img
                      alt={category}
                      src={category === 'crash-game' ? "/assets/img/icon-btn/crash-game-icon.png" : getCategoryIcon(category)}
                      className="HomeSection_icon"
                      style={{filter: "invert(1)"}}
                    />

                  <div className="HomeSection_label">
                      {category === 'crash-game' ? t('Crash_game') : category}
                    </div>

                  <div className="HomeSection_right">
                  <div className="HomeSection_headerLink" onClick={handleOpenCategoryModal}>
                                      {t('All')}
                                    </div>

                    <div className="HomeSection_caption">{games.length} {t('Games')}</div>
                  </div>
                </a>
              </div>

              <div className="justify-content-center multi-slider-box">
                {loading ? (
                  <Slider {...settings}>{renderLoadingGames()}</Slider>
                ) : games.length === 1 ? (
                  <>

                    {customClass === 'multiple' && (
                      <div className="multi-slider carousel slide">
                        <button className="carousel-control-prev w-aut" role="button" onClick={() => sliderRef.current.slickPrev()}>
                          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        </button>
                        <button className="carousel-control-next w-aut" role="button" onClick={() => sliderRef.current.slickNext()}>
                          <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        </button>
                      </div>
                    )}
                    <Slider {...settings} ref={sliderRef}>
                      <div className="HomeSectionCasinoGames_game" >
                        <div className="CasinoGameCard_root">
                          <div className="CasinoGamePreview_root" onClick={() => openGameModal(games[0].id)}>
                            <img
                              className="ResponsivePicture_img CasinoGamePreview_image"
                              src={games[0].thumbnail || 'default-image.jpg'}
                              alt={games[0].name}
                              loading="lazy"
                            />
                          </div>
                          <div className="CasinoGameCard_info CasinoGameCard_withProvider">
                            <div className="CasinoGameCard_provider">
                              <img alt={games[0].provider_name} src={getProviderIcon(games[0].provider_slug)} className="CasinoGameCard_icon" onClick={() => openGameModal(games[0].id)}/>
                              <p className="CasinoGameCard_name" onClick={() => openGameModal(games[0].id)}>{games[0].provider_name}</p>
                              <button style={{zIndex: "100", width: "12%", position: "absolute", height: "12%",left: "80%"}} onClick={
                                    () => {
                                      if(isLogged){
                                        updateFavoriteGame(games[0].id);
                                        setGames(prev =>
                                          prev.map(g =>
                                            g.id === games[0].id
                                              ? { ...g, favorite: Number(g.favorite) == 1 ? 0 : 1 }
                                              : g
                                          )
                                        );
                                      } else{
                                        setIsLoginModalOpen(true);
                                      }
                                    }  
                                  }>
                                    <svg className="" viewBox='0 0 50 50'>
                                      <path d="M38.7,8.9c-4.4-2.4-10.2-1.7-13.8,1.6c-3.7-3.3-9.4-4-13.9-1.6C7.2,11,4.8,15,4.8,19.4
                                        c0,1.2,0.2,2.5,0.6,3.5c1.9,8.6,18,18.8,18.7,19.2l0.8,0.5l0.8-0.5c0.7-0.4,16.7-10.6,18.6-19c0.4-1.2,0.6-2.4,0.6-3.7 
                                        C44.8,15,42.5,11,38.7,8.9z" fill={(Number(games[0].favorite) == 1) ? "red" : "transparent"} style={{ stroke: "red", strokeWidth: "4px" }}
                                      />
                                    </svg>

                                  </button>
                            </div>
                            <p className="CasinoGameCard_gameName" onClick={() => openGameModal(games[0].id)}>{games[0].name}</p>
                          </div>
                        </div>
                      </div>
                    </Slider>
                  </>

                ) : (
                  <>
                    {customClass === 'multiple' && (
                      <div className="multi-slider carousel slide">
                        <button className="carousel-control-prev w-aut" onClick={() => sliderRef.current.slickPrev()}>
                          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        </button>
                        <button className="carousel-control-next w-aut" onClick={() => sliderRef.current.slickNext()}>
                          <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        </button>
                      </div>
                    )}
                    <Slider {...settings} ref={sliderRef}>
                      {games.map((game) => {
                        // console.log(game.nome_provider); // ← залишено логування!
                        return (
                          <div key={game.id} className="HomeSectionCasinoGames_game" /* onClick={() => openGameModal(game.id)} */>
                            <div className="CasinoGameCard_root">
                              <div className="CasinoGamePreview_root" onClick={() => openGameModal(game.id)}>
                                <img
                                  className="ResponsivePicture_img CasinoGamePreview_image"
                                  src={game.thumbnail || 'default-image.jpg'}
                                  alt={game.name}
                                  loading="lazy"
                                />
                              </div>
                              <div className="CasinoGameCard_info CasinoGameCard_withProvider">
                                <div className="CasinoGameCard_provider">
                                  <img alt={game.provider_name} src={getProviderIcon(game.provider_slug)} className="CasinoGameCard_icon" onClick={() => openGameModal(game.id)}/>
                                  <p className="CasinoGameCard_name" onClick={() => openGameModal(game.id)}>{game.provider_name}</p>
                                  <button style={{zIndex: "100", width: "12%", position: "absolute", height: "12%",left: "80%"}} onClick={
                                    () => {
                                      if(isLogged){
                                        updateFavoriteGame(game.id);
                                        setGames(prev =>
                                          prev.map(g =>
                                            g.id === game.id
                                              ? { ...g, favorite: Number(g.favorite) == 1 ? 0 : 1 }
                                              : g
                                          )
                                        );
                                      } else{
                                        setIsLoginModalOpen(true);
                                      }
                                    }  
                                  }>
                                    <svg className="" viewBox='0 0 50 50'>
                                      <path d="M38.7,8.9c-4.4-2.4-10.2-1.7-13.8,1.6c-3.7-3.3-9.4-4-13.9-1.6C7.2,11,4.8,15,4.8,19.4
                                        c0,1.2,0.2,2.5,0.6,3.5c1.9,8.6,18,18.8,18.7,19.2l0.8,0.5l0.8-0.5c0.7-0.4,16.7-10.6,18.6-19c0.4-1.2,0.6-2.4,0.6-3.7 
                                        C44.8,15,42.5,11,38.7,8.9z" fill={(Number(game.favorite) == 1) ? "red" : "transparent"} style={{ stroke: "red", strokeWidth: "4px" }}
                                      />
                                    </svg>

                                  </button>
                                </div>
                                <p className="CasinoGameCard_gameName" title={game.name} onClick={() => openGameModal(game.id)}>{game.name}</p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  </>

                  
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showCategoryModal && (
        <LOAD_GAMES_BY_CATEGORY
          Game={Games}
          category={category}
          category_name={t(category === 'crash-game' ? 'Crash_game' : category)}
          onClose={handleCloseCategoryModal}
          AuthService={AuthService}
          isLogged={isLogged}
          setIsLoginModalOpen={setIsLoginModalOpen}
        />
      )}

      
    </>

    
  );
};

export default LoadCategory;
